const App = window.App || {};

export default App;
